import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PersonItem } from '@models/custom-fields.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ModalService } from '@services/modal/modal.service';
import { PersonCardComponent } from '@shared-components/person-card/person-card.component';

@Component({
  selector: 'ts-user-profile',
  templateUrl: './user-profile.component.html',
  imports: [CommonModule, PersonCardComponent, TranslationPipe]
})
export class UserProfileComponent {
  person: PersonItem;

  constructor(private modal_svc: ModalService, private activity_svc: ActivityManagerService) {}

  ngOnInit(): void {
    this.person = this.activity_svc.state().getOrderForPerson()!;
  }

  dismissModal(): void {
    this.modal_svc.dismissLastModal('Close click');
  }
}
